// @ts-nocheck
import { Tooltip } from "@shared/antd/tooltip";
import { Card } from "@shared/antd/card";
import { Icon } from "@shared/antd/icon";
import React from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { observable } from "mobx";
import { AllParticipantsTableComponent, IParticipant, ParticipantsTableComponent } from "./ui";
import { observer } from "mobx-react";
import { ConcourseRequest } from "../../../cuba/entities/base/tsadv_ConcourseRequest";
import { DataInstanceStore } from "@cuba-platform/react";
import { checkParticipantsInclude } from "./api/getParticipants";

export type partipantsTableProps = {
  setSelectedParticipants: (value: IParticipant[]) => void;
  selectedParticipants: IParticipant[];
  entityId: string;
  lang: string;
}
type State = {
  visible: boolean;
  status: boolean;
  onLoad: boolean;
}

type Props = {
  getStatusCode?: string | null;
  users?: DataInstanceStore<ConcourseRequest>;
  table: partipantsTableProps;
  setStatus: (value: boolean) => void;
}

@observer
class ParticipantsList extends React.Component<WrappedComponentProps & Props, State> {
  constructor(props: WrappedComponentProps & Props) {
    super(props);
    this.state = {
      visible: false,
      status: true,
      onLoad: true,
    };
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  deleteSelectedParticipants = () => {
    this.props.table.setSelectedParticipants([]);
  };
  deleteSelectedParticipant = (id: string) => {
    const filtered = this.props.table.selectedParticipants.filter(item => item.person_group_id !== id);
    this.props.table.setSelectedParticipants(filtered);
  };

  @observable selectedRowKey: string | undefined;

  handleRowSelectionChange = (selectedRowKeys: string[]) => {
    this.selectedRowKey = selectedRowKeys[0];
  };

  onLoadCheckStatus = () => {
    const status = this.props.getStatusCode;
    return !(status === "DRAFT" || status === "TO_BE_REVISED");
  };

  render() {
    const { visible, status } = this.state;
    const { showModal, handleCancel, deleteSelectedParticipants, props, deleteSelectedParticipant } = this;
    const { selectedParticipants, setSelectedParticipants } = props.table;
    const withi18n = (id: string) => {
      return props.intl.formatMessage({ id: id });
    };

    const selectParticipant = (item: IParticipant) => {
      const res = checkParticipantsInclude(selectedParticipants, item);
      if (res) {
        const newArray = [...selectedParticipants, item];
        setSelectedParticipants(newArray);
      }
    };

    return (
      <div id="participantsList">
        <Card
          title={<label>
            <Tooltip placement={"right"}
                     title={this.props.intl.formatMessage({ id: `concourseRequest.tooltip.concourseParticipants` })}>
              {withi18n("concourseRequest.input.concourseParticipants")}
              <Icon style={{ marginLeft: "5px" }} type="info-circle" />
            </Tooltip>
          </label>}
          className="generalInfo"
          size="small"
          style={{ marginTop: "12px", marginBottom: "16px" }}
        >
          <ParticipantsTableComponent
            deleteSelectedParticipants={deleteSelectedParticipants}
            deleteSelectedParticipant={deleteSelectedParticipant}
            selectedParticipants={selectedParticipants}
            select={selectParticipant}
            showModal={showModal}
            status={status}
            users={props.users}
            table={this.props.table}
          />
        </Card>
        {visible &&
          <AllParticipantsTableComponent
            modal={{ visible, handleCancel }}
            status={status}
            lang={props.table.lang}
            selectedParticipants={selectedParticipants}
            selectParticipant={selectParticipant} />
        }
      </div>
    );
  }

  componentDidUpdate(prevProps: Readonly<WrappedComponentProps & Props>, prevState: Readonly<State>, snapshot?: any) {
    if (this.props.getStatusCode && this.state.onLoad) this.setState({
      status: this.onLoadCheckStatus(),
      onLoad: false,
    });
  }
}

export const ParticipantsListComponent = injectIntl(ParticipantsList);
